define.alias("shared/components/shared/ui/education", "settings/components/shared/ui/education");